import { InjectionToken } from '@angular/core';

export const DP_DASHBOARD_TOKEN = new InjectionToken('Provide Observable with current dashboard');
